import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router";
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals'; // need to install module web-vitals


import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline'; 
import customTheme from './theme/theme';

// context
import {AuthProvider} from './Context/AuthContext';

// translation
import './i18n';

// Context
import {FilterContext,FilterContextProvider} from './Context/FilterCountext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>

  <ThemeProvider theme={customTheme}>
    <AuthProvider>
    <CssBaseline/>
     <BrowserRouter>
      <App />
     </BrowserRouter>
     </AuthProvider>
  </ThemeProvider>

  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
